/**
 * Brand metadata for Portfolio. Single source of truth.
 *
 * Import product name, domains, legal info from here — NEVER hardcode
 * "Portfolio" in components or copy. When the product name changes,
 * update tokens/brand.json only, then re-run build.
 *
 *   import { brand, PRODUCT_NAME } from '@investment-tracker/design-tokens/brand';
 */

export const brand = {
  "productName": "Provedo",
  "productNameShort": "Provedo",
  "tagline": "AI-native trader of your investments",
  "legalName": "TBD Ltd.",
  "domain": {
    "web": "localhost:3000",
    "api": "localhost:8080",
    "marketing": "localhost:3001"
  },
  "email": {
    "support": "support@localhost",
    "legal": "legal@localhost",
    "noreply": "noreply@localhost"
  },
  "logo": {
    "variants": [
      "full",
      "mark",
      "wordmark"
    ]
  }
};

export const PRODUCT_NAME = brand.productName;
export const PRODUCT_TAGLINE = brand.tagline;
